export const LOCAL_STORAGE_KEYS = {
  AUTH_INFO: 'authInfo',
  TENANT: 'tenant',
  SELECTED_TENANT: 'selectedTenant',
  TENANT_NAME: 'name',
  TENANT_APP: 'tenantApp',
  USER_ROLE: 'userRole',
  REDIRECT_URI: 'redirect_uri',
  BRANDING: 'branding',
};
